import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
  MenuItem,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import location from "../../assets/icon/location.png";
import rupees from "../../assets/icon/rupees.png";
import vacancy from "../../assets/icon/people.png";
import img from "../../assets/img/img.png";
import Footer from "../../common/Footer";
import MediaModelApp from "./MediaModal";
import AllMediaModelApp from "./AllMediaShow";
import { DateCp } from "../customerDetail/dateCp";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import ExperienceModal from "./ExperienceModal";
import EducationModal from "./EducationModal";
import ConfirmDelete from "./confirmDelete";
import { addJobProfile, getJobProfile, updateJobProfile } from "./jobListApi";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { routePath } from "../../constants/routePath";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils";

export default function EditProfile() {
  const { id } = useParams();
  const [value, setValue] = useState("15");
  const navigate = useNavigate();
  const [experiences, setExperiences] = useState([]);
  const [openExperience, setOpenExperience] = useState(false);
  const [educations, setEducations] = useState([]);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [openEducation, setOpenEducation] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteType, setDeleteType] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editEducationIndex, setEditEducationIndex] = useState(null);
  const [editEducationData, setEditEducationData] = useState(null);
 const [editExpIndex, setEditExpIndex] = useState(null);
 const [editExpData, setEditExpData] = useState(null);

  const struct = {
    name: "",
    designation: "",
    mobileNo: "",
    emailId: "",
    dateOfBirth: null,
    address: "",
    city: "",
    gender: "",
    skills: "",
    specializations: "",
    isImmediateAvailable: true,
    readyToJoinWithinDays: "",
    currentSalary: 0,
    expectedSalary: 0,
    education: [
      // {
      //   courseName: "",
      //   instituteName: "",
      //   universityName: "",
      //   dateOfPassing: "",
      //   percentage: 0,
      // },
    ],
    experience: [
      // {
      //   salonName: "",
      //   fromDate: "",
      //   toDate: "",
      //   designation: "",
      //   city: "",
      // },
    ],
  };
  const [profile, setProfile] = useState({ ...struct });

  const [SelectedStartDate, setSelectedStartDate] = useState(null);
  const [SelectedEndDate, setSelectedEndDate] = useState(null);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  // useEffect(() => {
  //   getJobProfile().then((res) => {
  //     const data = res.data.data;

  //     setProfile({
  //       ...data,
  //       dateOfBirth: data.dateOfBirth ? dayjs(data.dateOfBirth) : null,
  //     });

  //   });
  // }, []);
  useEffect(() => {
    getJobProfile().then((res) => {
      const data = res?.data?.data;

      if (!data) {
        // ➕ ADD MODE
        setIsEditMode(false);
        setProfile({ ...struct });
        return;
      }

      // ✏️ EDIT MODE
      setIsEditMode(true);
      setProfile({
        ...struct,
        ...data,
        dateOfBirth: data.dateOfBirth ? dayjs(data.dateOfBirth) : null,
      });
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const gender = (e) => {
    setProfile((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };
  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  const options = [
    { label: "Immediate", value: "Immediate" },
    { label: "15", value: "15" },
    { label: "30", value: "30" },
    { label: "60", value: "60" },
  ];

  const labelStyle1 = {
    fontWeight: 600,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  const valueStyle = {
    fontWeight: 500,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
  };
  const handleDeleteEducation = (index) => {
    const updatedEducation = profile.education.filter((_, i) => i !== index);

    setProfile((prev) => ({
      ...prev,
      education: updatedEducation,
    }));

    updateJobProfile({
      ...profile,
      education: updatedEducation,
    });
  };

  const handleDeleteExperience = (index) => {
    const updatedEducation = profile.experience.filter((_, i) => i !== index);

    setProfile((prev) => ({
      ...prev,
      experience: updatedEducation,
    }));

    updateJobProfile({
      ...profile,
      experience: updatedEducation,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      ...profile,
      currentSalary: Number(profile.currentSalary) || 0,
      expectedSalary: Number(profile.expectedSalary) || 0,
      dateOfBirth: profile.dateOfBirth
        ? dayjs(profile.dateOfBirth).format("YYYY-MM-DDTHH:mm:ss")
        : null,
    };

    if (!isEditMode) {
      addJobProfile(payload).then(() => {
        setIsEditMode(true);
        getJobProfile().then((res) => {
          const data = res?.data?.data;
          if (!data) return;

          setProfile({
            ...struct,
            ...data,
            dateOfBirth: data.dateOfBirth ? dayjs(data.dateOfBirth) : null,
          });
          Swal.fire({
            text: "Profile added successfully",
            icon: "success",
            ...swalAlertPopProps,
          });
        });
        navigate(routePath.MYJOBPROFILE);
      });
      return;
    }
    updateJobProfile(payload).then(() => {
      getJobProfile().then((res) => {
        const data = res.data.data;
        setProfile({
          ...struct,
          ...data,
          dateOfBirth: data.dateOfBirth ? dayjs(data.dateOfBirth) : null,
        });
        Swal.fire({
          text: "Profile updated successfully",
          icon: "success",
          ...swalAlertPopProps,
        });
        console.table(res.data.data);
      });
      navigate(routePath.MYJOBPROFILE);
    });
  };
  return (
    <>
      <Box sx={{ backgroundColor: "#C0BFFF" }}>
        <Box sx={{ minHeight: "100vh", p: { sm: 3, xs: 0 } }}>
          <Box sx={{ display: "flex", gap: { md: 20, sm: 12, xs: 8 } }}>
            {/* Back Icon */}
            <KeyboardBackspaceIcon
              onClick={() => navigate("/jobs")}
              sx={{ fontSize: 30, color: "#01008B", mb: 2, cursor: "pointer" }}
            />
            <Typography
              sx={{
                fontSize: { md: 30, sm: 22, xs: 20 },
                color: "#01008B",
                cursor: "pointer",
                fontWeight: 700,
                mb: 1,
              }}
            >
              {isEditMode ? "Edit" : "Create"} Profile
            </Typography>
          </Box>
          {/* Job Card */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              px: { xs: 1.5, sm: 3, md: 10, lg: 20 },
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <form onSubmit={handleSubmit}>
                <Grid container alignItems="center" spacing={3}>
                  {/* Logo */}
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        id="name"
                        size="small"
                        label="Name"
                        name="name"
                        value={profile?.name}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputLabelProps={{
                          sx: {
                            // color: "#545454",
                            // fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // paddingX: "7px",
                          },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        id="designation "
                        label="Designation"
                        size="small"
                        name="designation"
                        value={profile?.designation}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputLabelProps={{
                          sx: {
                            // color: "#545454",
                            // fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // paddingX: "7px",
                          },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        id="mobileno"
                        name="mobileNo"
                        value={profile?.mobileNo}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        label="Mobile Number"
                        size="small"
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            // color: "#545454",
                            // fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // paddingX: "7px",
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        id="mailId"
                        size="small"
                        label="Email Id"
                        name="emailId"
                        value={profile?.emailId}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputLabelProps={{
                          sx: {
                            // color: "#545454",
                            // fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // paddingX: "7px",
                          },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    sm={4}
                    xs={12}
                    sx={{ paddingRight: { sm: "5px", xs: "0px" } }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date of Birth"
                        value={profile?.dateOfBirth ?? null}
                        onChange={(newValue) =>
                          setProfile((prev) => ({
                            ...prev,
                            dateOfBirth: newValue,
                          }))
                        }
                        slotProps={{
                          textField: { size: "small", fullWidth: true },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        id="address"
                        size="small"
                        label="Address"
                        name="address"
                        value={profile?.address}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputLabelProps={{
                          sx: {
                            // color: "#545454",
                            // fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // paddingX: "7px",
                          },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        id="city"
                        size="small"
                        label="City"
                        name="city"
                        value={profile?.city}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputLabelProps={{
                          sx: {
                            // color: "#545454",
                            // fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // paddingX: "7px",
                          },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={6} sm={4}>
                    <FormControl>
                      <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        className="mulish"
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 600,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Gender:
                        </Typography>
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                      >
                        <FormControlLabel
                          value="female"
                          control={<Radio />}
                          label={
                            <Typography
                              variant="body2"
                              sx={{
                                whiteSpace: "nowrap",
                                fontWeight: 500,
                                color: "#01008B",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              Female
                            </Typography>
                          }
                          checked={
                            profile.gender == "female" ||
                            profile.gender == "Female"
                          }
                          className="mulish"
                          onClick={gender}
                        />
                        <FormControlLabel
                          value="male"
                          control={<Radio />}
                          checked={
                            profile.gender == "male" || profile.gender == "Male"
                          }
                          label={
                            <Typography
                              variant="body2"
                              sx={{
                                whiteSpace: "nowrap",
                                fontWeight: 500,
                                color: "#01008B",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              Male
                            </Typography>
                          }
                          className="mulish"
                          onClick={gender}
                        />
                        <FormControlLabel
                          value="other"
                          control={<Radio />}
                          checked={
                            profile.gender == "other" ||
                            profile.gender == "Other"
                          }
                          label={
                            <Typography
                              variant="body2"
                              sx={{
                                whiteSpace: "nowrap",
                                fontWeight: 500,
                                color: "#01008B",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              Other
                            </Typography>
                          }
                          className="mulish"
                          onClick={gender}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Preferred Location"
                      // name="name"
                      // value={profile?.name}
                      // onChange={(e) => {
                      //   handleChange(e);
                      // }}
                      InputLabelProps={{
                        sx: {
                          // color: "#545454",
                          // fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          // fontWeight: 500,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Box
                      sx={{
                        border: "1.5px solid #01008B",
                        borderRadius: "8px",
                        p: 2,
                        // pt: 4,

                        position: "relative",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          position: "absolute",
                          // top: "-12px",
                          // left: "12px",
                          backgroundColor: "#fff",
                          fontWeight: 600,
                          color: "#01008B",
                          px: 1,
                          zIndex: 1,
                        }}
                      >
                        Education :
                      </Typography>

                      <Button
                        variant="contained"
                        sx={{
                          position: "absolute",
                          right: "12px",
                          height: "32px",
                          backgroundColor: "#14008B",
                          fontSize: { xs: "12px", sm: "13px", md: "14px" },
                          textTransform: "none",
                          borderRadius: "24px",
                          zIndex: 1,
                        }}
                        endIcon={<AddIcon />}
                        onClick={() => setOpenEducation(true)}
                      >
                        Add
                      </Button>

                      <Grid
                        container
                        spacing={3}
                        sx={{ mt: 1, py: 2, px: { xs: 0, sm: 2 } }}
                        justifyContent="center"
                      >
                        {profile?.education?.map((item, index) => {
                          return (
                            <Grid item xs={12} md={6}>
                              <Box
                                sx={{
                                  p: 2,
                                  boxShadow: "0px 4px 10px rgba(0,0,0,0.12)",
                                  borderRadius: "8px",
                                  position: "relative",
                                  backgroundColor: "#fff",
                                }}
                              >
                                <DeleteIcon
                                  sx={{
                                    position: "absolute",
                                    top: 10,
                                    right: 10,
                                    color: "#01008B",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setDeleteType("education");
                                    setDeleteIndex(index);
                                    setConfirmOpen(true);
                                  }}
                                />

                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns: "140px 1fr",
                                    rowGap: "10px",
                                  }}
                                >
                                  <Typography sx={labelStyle1}>
                                    Course Name :
                                  </Typography>
                                  <Typography sx={valueStyle}>
                                    {item?.courseName}
                                  </Typography>

                                  <Typography sx={labelStyle1}>
                                    Institute Name :
                                  </Typography>
                                  <Typography sx={valueStyle}>
                                    {item.instituteName}
                                  </Typography>

                                  <Typography sx={labelStyle1}>
                                    University Name :
                                  </Typography>
                                  <Typography sx={valueStyle}>
                                    {" "}
                                    {item.universityName}{" "}
                                  </Typography>

                                  <Typography sx={labelStyle1}>
                                    Date of Passing :
                                  </Typography>
                                  <Typography sx={valueStyle}>
                                    {formatDate(item.dateOfPassing)}
                                  </Typography>

                                  <Typography sx={labelStyle1}>
                                    Percentage :
                                  </Typography>
                                  <Typography sx={valueStyle}>
                                    {" "}
                                    {item.percentage}{" "}
                                  </Typography>
                                </Box>

                                <Button
                                  fullWidth
                                  variant="contained"
                                  sx={{
                                    backgroundColor: "#01008B",
                                    fontWeight: 600,
                                    mt: 2,
                                    textTransform: "none",
                                  }}
                                  onClick={() => {
                                    setEditEducationIndex(index);
                                    setEditEducationData(item); // pass current education
                                    setOpenEducation(true);
                                  }}
                                >
                                  Edit
                                </Button>
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Box
                      sx={{
                        border: "1.5px solid #01008B",
                        borderRadius: "8px",
                        p: 2,
                        // pt: 4,

                        position: "relative",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          position: "absolute",
                          // top: "-12px",
                          // left: "12px",
                          backgroundColor: "#fff",
                          fontWeight: 600,
                          color: "#01008B",
                          px: 1,
                          zIndex: 1,
                        }}
                      >
                        Experience :
                      </Typography>

                      <Button
                        variant="contained"
                        sx={{
                          position: "absolute",
                          right: "12px",
                          height: "32px",
                          backgroundColor: "#14008B",
                          fontSize: { xs: "12px", sm: "13px", md: "14px" },
                          textTransform: "none",
                          borderRadius: "24px",
                          zIndex: 1,
                        }}
                        endIcon={<AddIcon />}
                        onClick={() => setOpenExperience(true)}
                      >
                        Add
                      </Button>

                      <Grid
                        container
                        spacing={3}
                        sx={{ mt: 1, py: 2, px: { xs: 0, sm: 2 } }}
                        justifyContent="center"
                      >
                        {profile?.experience?.map((item, index) => {
                          return (
                            <Grid item xs={12} md={6}>
                              <Box
                                sx={{
                                  p: 2,
                                  boxShadow: "0px 4px 10px rgba(0,0,0,0.12)",
                                  borderRadius: "8px",
                                  position: "relative",
                                  backgroundColor: "#fff",
                                }}
                              >
                                <DeleteIcon
                                  sx={{
                                    position: "absolute",
                                    top: 10,
                                    right: 10,
                                    color: "#01008B",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setDeleteType("experience");
                                    setDeleteIndex(index);
                                    setConfirmOpen(true);
                                  }}
                                />

                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns: "140px 1fr",
                                    rowGap: "10px",
                                  }}
                                >
                                  <Typography sx={labelStyle1}>
                                    Salon Name :
                                  </Typography>
                                  <Typography sx={valueStyle}>
                                    {item.salonName}
                                  </Typography>

                                  <Typography sx={labelStyle1}>
                                    From :
                                  </Typography>
                                  <Typography sx={valueStyle}>
                                    {formatDate(item.fromDate)} To{" "}
                                    {formatDate(item.toDate)}
                                  </Typography>

                                  <Typography sx={labelStyle1}>
                                    Designation :
                                  </Typography>
                                  <Typography sx={valueStyle}>
                                    {item.designation}{" "}
                                  </Typography>

                                  <Typography sx={labelStyle1}>
                                    City :
                                  </Typography>
                                  <Typography sx={valueStyle}>
                                    {item.city}
                                  </Typography>
                                </Box>

                                <Button
                                  fullWidth
                                  variant="contained"
                                  sx={{
                                    backgroundColor: "#01008B",
                                    fontWeight: 600,
                                    mt: 2,
                                    textTransform: "none",
                                  }}
                                  onClick={() => {
                                    setEditExpIndex(index);
                                    setEditExpData(item); // pass current education
                                    setOpenExperience(true);
                                  }}
                                >
                                  Edit
                                </Button>
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Box>
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        id="skills"
                        size="small"
                        label="Skills"
                        name="skills"
                        value={profile?.skills}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputLabelProps={{
                          sx: {
                            // color: "#545454",
                            // fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // paddingX: "7px",
                          },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        id="specialization"
                        size="small"
                        label="Specialization"
                        name="specializations"
                        value={profile?.specializations}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputLabelProps={{
                          sx: {
                            // color: "#545454",
                            // fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // paddingX: "7px",
                          },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 7,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          whiteSpace: "nowrap",
                        }}
                      >
                        Immediate Available :
                      </Typography>

                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        onChange={(e) =>
                          setProfile((prev) => ({
                            ...prev,
                            isImmediateAvailable: e.target.value === "true",
                          }))
                        }
                      >
                        <FormControlLabel
                          value="true"
                          control={<Radio />}
                          label={
                            <Typography
                              variant="body2"
                              sx={{
                                whiteSpace: "nowrap",
                                fontWeight: 500,
                                color: "#01008B",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              Yes
                            </Typography>
                          }
                          checked={profile.isImmediateAvailable == true}
                          className="mulish"
                          // onClick={incentive}
                        />
                        <FormControlLabel
                          value="false"
                          control={<Radio />}
                          checked={profile.isImmediateAvailable == false}
                          label={
                            <Typography
                              variant="body2"
                              sx={{
                                whiteSpace: "nowrap",
                                fontWeight: 500,
                                color: "#01008B",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              No
                            </Typography>
                          }
                          className="mulish"
                          // onClick={incentive}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          whiteSpace: "nowrap",
                        }}
                      >
                        Ready to join within:
                      </Typography>

                      <TextField
                        select
                        label="Days"
                        name="readyToJoinWithinDays"
                        size="small"
                        value={profile?.readyToJoinWithinDays}
                        onChange={handleChange}
                        InputProps={{
                          sx: {
                            background: "#fff",
                            borderRadius: 1,
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 500,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                        sx={{ minWidth: 120 }}
                      >
                        <MenuItem value={"Immediate"}>Immediate</MenuItem>
                        <MenuItem value={"15"}>15</MenuItem>{" "}
                        <MenuItem value={"30"}>20</MenuItem>{" "}
                        <MenuItem value={"60"}>60</MenuItem>
                      </TextField>

                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Days
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        id="currentSalary"
                        size="small"
                        label="Current Salary"
                        name="currentSalary"
                        value={profile?.currentSalary}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputLabelProps={{
                          sx: {
                            // color: "#545454",
                            // fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // paddingX: "7px",
                          },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // fontWeight: 500,
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        size="small"
                        label="Expected Salary"
                        name="expectedSalary"
                        value={profile?.expectedSalary}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        InputProps={{
                          className: "mulish",

                          sx: {
                            background: "#fff",
                            borderRadius: 1,
                            cursor: "pointer",
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 500,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                        InputLabelProps={{
                          className: "mulish",

                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{
                          backgroundColor: "#01008B",
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: { sm: 13, md: 16, xs: 12 },
                          borderRadius: 1,
                          width: { xs: "100%", sm: "50%", md: "50%" },
                        }}
                      >
                        {isEditMode ? "Update" : "Create Profile"}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Box>
        </Box>
        <Box sx={{ pt: 5 }}>
          <Footer />
        </Box>

        <ExperienceModal
          open={openExperience}
          editData={editExpData} // 👈 pass data
          handleClose={() => {
            setOpenExperience(false);
            setEditEducationIndex(null);
            setEditEducationData(null);
          }}
          onSave={(data) => {
            // const updatedExperience = [...profile.experience, data];
            let updatedExperience = [];

            if (editExpIndex !== null) {
              // ✏️ EDIT MODE
              updatedExperience = profile.experience.map((item, idx) =>
                idx === editExpIndex ? data : item,
              );
            } else {
              // ➕ ADD MODE
              updatedExperience = [...profile.experience, data];
            }
            // Always update local state
            setProfile((prev) => ({
              ...prev,
              experience: updatedExperience,
            }));

            // ✏️ Update API ONLY in edit mode
            if (isEditMode) {
              updateJobProfile({
                ...profile,
                experience: updatedExperience,
              }).then(() => {
                getJobProfile().then((res) => {
                  const data = res?.data?.data;
                  if (!data) return;

                  setProfile({
                    ...struct,
                    ...data,
                    dateOfBirth: data.dateOfBirth
                      ? dayjs(data.dateOfBirth)
                      : null,
                  });
                });
              });
            }
            setEditEducationIndex(null);
            setEditEducationData(null); // pass current education
            setOpenEducation(null);
          }}
        />

        <EducationModal
          editData={editEducationData} // 👈 pass data
          open={openEducation}
          handleClose={() => {
            setEditEducationIndex(null);
            setEditEducationData(null);
            setOpenEducation(false);
          }}
          onSave={(data) => {
            // const updatedEducation = [...profile.education, data];
            let updatedEducation = [];

            if (editEducationIndex !== null) {
              // ✏️ EDIT MODE
              updatedEducation = profile.education.map((item, idx) =>
                idx === editEducationIndex ? data : item,
              );
            } else {
              // ➕ ADD MODE
              updatedEducation = [...profile.education, data];
            }

            // Always update local state
            setProfile((prev) => ({
              ...prev,
              education: updatedEducation,
            }));

            // ✏️ Update API ONLY in edit mode
            if (isEditMode) {
              updateJobProfile({
                ...profile,
                education: updatedEducation,
              }).then(() => {
                getJobProfile().then((res) => {
                  const data = res?.data?.data;
                  if (!data) return;

                  setProfile({
                    ...struct,
                    ...data,
                    dateOfBirth: data.dateOfBirth
                      ? dayjs(data.dateOfBirth)
                      : null,
                  });
                });
              });
            }
            setOpenEducation(false);
            setEditEducationIndex(null);
            setEditEducationData(null);
          }}
        />

        <ConfirmDelete
          open={confirmOpen}
          title={
            deleteType === "education"
              ? "Do you want to remove Education Detail?"
              : "Do you want to remove Experience Detail?"
          }
          onClose={() => {
            setConfirmOpen(false);
            setDeleteIndex(null);
            setDeleteType("");
          }}
          onConfirm={() => {
            if (deleteType === "education" && deleteIndex !== null) {
              handleDeleteEducation(deleteIndex);
            }
            if (deleteType === "experience" && deleteIndex !== null) {
              handleDeleteExperience(deleteIndex);
            }
            setConfirmOpen(false);
          }}
        />
      </Box>
    </>
  );
}
